export default "__VITE_ASSET__BwuTLjoH__"